// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28759":"2ceb5e21","74326":"0201d72b","93406":"b5d83504"}[chunkId] + ".chunk.css";
};